module.exports = "https://cdn.dove.it/_next/static/public/assets/altroconsumo/hero-small.a1a1d3e77ee6c43585a346ab499377ef.jpg";